module.exports = __webpack_public_path__ + "img/22.9c46a0a0.jpeg";